/**
 * Feedback Container Component
 * Like/Dislike and action buttons
 */

import React from 'react';
import { spacing } from '@/design-system/utils';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { FeedbackItem } from './FeedbackItem';

export interface FeedbackContainerProps {
  messageId?: string;
  onLike?: () => void;
  onDislike?: () => void;
  onCopy?: () => void;
  onShare?: () => void;
  onBookmark?: () => void;
  liked?: boolean;
  disliked?: boolean;
}

/**
 * Icon Wrapper Component
 * Single Responsibility: Wraps feedback icons with consistent styling
 *
 * Best Practice: Uses regular <img> tag for SVG icons instead of Next.js Image
 * because SVGs don't need optimization and load faster from browser cache
 */
interface IconWrapperProps {
  src: string;
  alt: string;
  opacity?: number;
}

const IconWrapper: React.FC<IconWrapperProps> = ({ src, alt, opacity = 1 }) => {
  return (
    <div
      style={{
        width: '20px',
        height: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {/* Using regular img tag for SVG icons (best practice) */}
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={src}
        alt={alt}
        width={20}
        height={20}
        style={{
          opacity,
        }}
      />
    </div>
  );
};

export const FeedbackContainer: React.FC<FeedbackContainerProps> = ({
  onCopy,
  onShare,
}) => {
  // Detect mobile view (less than 768px)
  const isMobile = useMediaQuery('(max-width: 767px)');

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingTop: spacing[4],
        paddingBottom: spacing[4],
      }}
    >
      {/* Left side - Like/Dislike */}
      <div style={{ display: 'flex', gap: spacing[3] }}>
        {/* {onLike && (
          <FeedbackItem
            icon={
              <IconWrapper
                src='/assets/images/icons/like.svg'
                alt='Like'
                opacity={liked ? 1 : 0.6}
              />
            }
            onClick={onLike}
          />
        )}
        {onDislike && (
          <FeedbackItem
            icon={
              <IconWrapper
                src='/assets/images/icons/dislike.svg'
                alt='Dislike'
                opacity={disliked ? 1 : 0.6}
              />
            }
            onClick={onDislike}
          />
        )} */}
      </div>

      {/* Right side - Copy/Share/Bookmark */}
      <div style={{ display: 'flex', gap: spacing[3] }}>
        {onCopy && (
          <FeedbackItem
            icon={
              <IconWrapper src='/assets/images/icons/copy.svg' alt='Copy' />
            }
            label={isMobile ? undefined : 'Copy'}
            onClick={onCopy}
          />
        )}
        {onShare && (
          <FeedbackItem
            icon={
              <IconWrapper src='/assets/images/icons/share.svg' alt='Share' />
            }
            label={isMobile ? undefined : 'Share'}
            onClick={onShare}
          />
        )}
        {/* {onBookmark && (
          <FeedbackItem
            icon={
              <IconWrapper
                src='/assets/images/icons/bookmark.svg'
                alt='Bookmark'
              />
            }
            label={isMobile ? undefined : 'Bookmark'}
            onClick={onBookmark}
          />
        )} */}
      </div>
    </div>
  );
};
